<template>
    <div class="part-wrap section-wrap">
        <Collapse v-model="part_value">
            <div class="group-title" >款式选择</div>
            <Panel :name="item.category_name_cn" v-for="(item,index) in cal_part" :key="'part-list-'+index" v-show="item.is_show>0">
                <div class="part-title">
                    <span class="title">{{ item.category_name_cn}}</span>
                    <span class="value">{{ part_list[item.category_key] }}</span>
                </div>
                <div slot="content" class="cate-box">
                    <template v-for="oItem in  item.option_list">
                        <div class="cate" @click="choose_part(item.category_key, item.category_name_cn, oItem.part_name_cn,oItem.part_key, oItem.model_path, item.no_cad)"
                             :class="{'cate-active':part_list[item.category_key]==oItem.part_name_cn,'select-active':part_list[item.category_key]==oItem.part_name_cn}">
                            <div class="img">
                                <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                            </div>
                            <div> {{ oItem.part_name_cn }}</div>
                        </div>
                    </template>
                    <div class="clear"></div>
                </div>
            </Panel>
            <div class="group-title" >辅料搭配</div>
            <Panel :name="item.deep_name" v-for="(item,index) in accessory" :key="'accessory-list-'+index">
                <template v-if="item.deep_key==='AF'">
                    <div class="part-title">
                        <span class="title">{{ item.deep_name}}</span>
                        <span class="value">{{ form_data.fl_fabric_key }}</span>
                    </div>
                    <div slot="content">
                        <div class="cate-box">
                            <RadioGroup v-model="filter_accessory[`AF`]" >
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3" ><span>高档</span></Radio>
                                <Radio :label="2" ><span>中档</span></Radio>
                                <Radio :label="1" ><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_fl_fabric_key(item.deep_key, item.deep_name,oItem.text,oItem.fabric_key, oItem.material, oItem.color)"
                                     :class="{'cate-active':form_data.fl_fabric_key===oItem.fabric_key,'select-active':form_data.fl_fabric_key===oItem.fabric_key}"
                                     v-show="filter_accessory[`AF`]==0||oItem.dangci==filter_accessory[`AF`]"
                                >
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div>{{ oItem.text }}</div>
                                </div>
                            </template>
                        </div>

                        <div class="clear"></div>
                    </div>
                </template>
                <template v-else-if="item.deep_key==='AC'">
                    <div class="part-title">
                        <span class="title">{{ item.deep_name}}</span>
                        <span class="value">{{ form_data.fl2_fabric_key }}</span>
                    </div>
                    <div slot="content">
                        <div class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_fl2_fabric_key(item.deep_key, item.deep_name,oItem.text,oItem.fabric_key, {...oItem.material, sync_type: oItem.sync_type}, oItem.color)"
                                     :class="{'cate-active':form_data.fl2_fabric_key===oItem.fabric_key,'select-active':form_data.fl2_fabric_key===oItem.fabric_key}"
                                     v-show="filter_accessory[`AF`]==0||oItem.dangci==filter_accessory[`AF`]"
                                >
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                        </div>

                        <div class="clear"></div>
                    </div>
                </template>
                <template v-else>
                    <div class="part-title">
                        <span class="title">{{ item.deep_name}}</span>
                        <span class="value">{{ accessory_list[item.deep_key] }}</span>
                    </div>
                    <div slot="content">
                        <div class="cate-box">
                            <RadioGroup v-model="filter_accessory[item.deep_key]" >
                                <Radio :label="0"><span>全部</span></Radio>
                                <Radio :label="3" ><span>高档</span></Radio>
                                <Radio :label="2" ><span>中档</span></Radio>
                                <Radio :label="1" ><span>普通</span></Radio>
                            </RadioGroup>
                        </div>
                        <div class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_accessory(item.deep_key, item.deep_name, oItem.text, oItem.key)"
                                     :class="{'cate-active':accessory_list[item.deep_key]==oItem.text,'select-active':accessory_list[item.deep_key]==oItem.text}"
                                     v-show="filter_accessory[item.deep_key]==0||oItem.dangci==filter_accessory[item.deep_key]"
                                >
                                    <div class="img" >
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'"   />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                        </div>

                        <div class="clear"></div>
                    </div>
                </template>
            </Panel>
            <div class="group-title" >插花眼</div>
            <Panel :name="item.deep_name" v-for="(item,index) in cal_flower" :key="'flower-list-'+index">
                <div class="part-title">
                    <span class="title">{{ item.deep_name}}</span>
                    <span class="value">{{ flower_list[item.deep_key] }}</span>
                </div>
                <div slot="content" class="cate-box">
                    <template v-for="oItem in  item.option_list">
                        <div class="cate" @click="choose_flower(item.deep_key, item.deep_name, oItem.text, oItem.key)"
                             :class="{'cate-active':flower_list[item.deep_key]==oItem.text,'select-active':flower_list[item.deep_key]==oItem.text}">
                            <div class="img">
                                <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                            </div>
                            <div> {{ oItem.text }}</div>
                        </div>
                    </template>
                    <div class="clear"></div>
                </div>
            </Panel>
        </Collapse>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Part",
        data() {
            return {
                filter_accessory: {},
                part_value: [],
                cal_part: [],
                cal_flower: [],
                relate_map_part: new Map(),
                relate_map_flower: new Map(),
            }
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                part: (state) => state.mtm.picked_category.hasOwnProperty('part') ? state.mtm.picked_category.part : Array.of(),
                flower: (state) => state.mtm.picked_category.hasOwnProperty('flower') ? state.mtm.picked_category.flower : Array.of(),
                accessory: (state) => state.mtm.picked_category.hasOwnProperty('accessory') ? state.mtm.picked_category.accessory : Array.of(),
                part_list: (state) => state.mtm.form_data.part_list,
                accessory_list: (state) => state.mtm.form_data.accessory_list,
                flower_list: (state) => state.mtm.form_data.flower_list,
                form_data: (state) => state.mtm.form_data,
            }),
        },
        methods: {
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            choose_accessory(deep_key, deep_name, option_name, option_key) {
                this.$store.commit('mtm/choose_accessory', {
                    deep_key,  deep_name, option_name, option_key
                })
                let idx = this.part_value.findIndex(v=>v===deep_name)
                this.part_value.splice(idx, 1)
            },
            choose_flower(deep_key, deep_name, option_name, option_key) {
                this.$store.commit('mtm/choose_flower', {
                    deep_key,  deep_name, option_name, option_key
                })

                // 修改被影响的选项
                if(this.relate_map_flower.has(option_name)) {
                    // 每个关联显示的部位
                    for(let key_self in this.relate_map_flower.get(option_name)) {
                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_flower.get(option_name)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for(let key_another in this.flower_list) {
                            let part_another = this.flower.find(v=>v.deep_key === key_another)
                            let relate_another = part_another.option_list.find(v=>v.text==this.flower_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            let ldd = {option_list: (relate_another && this.relate_map_flower.has(relate_another.text) && this.relate_map_flower.get(relate_another.text)[key_self] ? this.relate_map_flower.get(relate_another.text)[key_self] : [])}
                            if(ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v=>intersect_keys.includes(v.text))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.text, v])).values()]
                        }

                        if((this.flower.map(v=>v.deep_key)).includes(key_self)) {
                            let idx = this.flower.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if(idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$set(this.cal_flower[idx], 'option_list', filter_option_list)
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_flower', {
                                deep_key: key_self
                            })
                        }

                    }
                }
                let idx = this.part_value.findIndex(v=>v===deep_name)
                this.part_value.splice(idx, 1)
            },
            choose_part(part_key, part_name, option_name, option_key, model_path, no_cad) {
                this.$store.commit('mtm/choose_part', {
                    part_key, part_name, option_name, option_key, model_path, no_cad
                })
                // 修改被影响的选项
                if(this.relate_map_part.has(option_key)) {
                    // 每个关联显示的部位
                    for(let key_self in this.relate_map_part.get(option_key)) {
                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_part.get(option_key)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for(let key_another in this.part_list) {
                            let part_another = this.part.find(v=>v.category_key === key_another)
                            let relate_another = part_another.option_list.find(v=>v.part_name_cn==this.part_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            // let ldd = relate_another && relate_another.hasOwnProperty('relate_part') && relate_another.relate_part.find(v=>v.category_key == key_self)? relate_another.relate_part.find(v=>v.category_key == key_self) : {option_list: []}
                            let ldd = {option_list: (relate_another && this.relate_map_part.has(relate_another.part_key) && this.relate_map_part.get(relate_another.part_key)[key_self] ? this.relate_map_part.get(relate_another.part_key)[key_self] : [])}
                            if(ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.part_key)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.part_key)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v=>intersect_keys.includes(v.part_key))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.part_key, v])).values()]
                        }

                        if((this.part.map(v=>v.category_key)).includes(key_self)) {
                            let idx = this.part.findIndex((v) => {
                                return v.category_key === key_self
                            })
                            if(idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$set(this.cal_part[idx], 'option_list', filter_option_list)
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_part', {
                                part_key: key_self
                            })
                        }

                        if((this.flower.map(v=>v.deep_key)).includes(key_self)) {
                            let idx = this.flower.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if(idx === -1) {
                                continue;
                            }

                            filter_option_list = filter_option_list.map(v=> {return {text: v.part_name_cn, image: v.image, key: v.part_key}})
                            // 填充计算后选项
                            this.$set(this.cal_flower[idx], 'option_list', filter_option_list)
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_flower', {
                                deep_key: key_self
                            })
                        }

                        // if(filter_option_list.length > 0) {
                        //     let allow_option_name = filter_option_list.map(v=>v.part_name_cn)
                        //     // 选项溢出需重新选择第一项
                        //     if(!allow_option_name.includes(this.part_list[key_self])) {
                        //         let new_part = this.part.find(v => v.category_key === key_self)
                        //         let new_option = new_part.option_list[0]
                        //         this.$store.commit('mtm/choose_part', {
                        //             part_key: new_part.category_key, part_name:new_part.category_name_cn, option_name:new_option.part_name_cn, option_key:new_option.part_key, model_path:"", no_cad:new_part.no_cad
                        //         })
                        //     }
                        // }
                    }
                }
                let idx = this.part_value.findIndex(v=>v===part_name)
                this.part_value.splice(idx, 1)
            },
            choose_fl_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, null)
                this.$store.commit('mtm/choose_fl_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_fl2_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_accessory(deep_key, deep_name, option_name, null)
                this.$store.commit('mtm/choose_fl2_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
        },
        mounted() {
            this.cal_part = this.part
            for(let j in this.part) {
                let o1 = this.part[j].option_list
                for(let k in o1) {
                    let o2 = this.part[j].option_list[k]
                    if(!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for(let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.category_key] = o3.option_list
                    }
                    this.relate_map_part.set(o2.part_key, obj)
                }
            }
            this.cal_flower = this.flower
            for(let j in this.flower) {
                let o1 = this.flower[j].option_list
                for(let k in o1) {
                    let o2 = this.flower[j].option_list[k]
                    if(!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for(let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.deep_key] = o3.option_list
                    }
                    this.relate_map_flower.set(o2.text, obj)
                }
            }
            // 展开Collapse
            if([...this.part, ...this.accessory, ...this.flower].length < 5) {
                for (let index_outer in this.part) {
                    this.part_value.push(this.part[index_outer].category_name_cn)
                }
                for (let index_outer in this.accessory) {
                    this.part_value.push(this.accessory[index_outer].deep_name)
                }
                for (let index_outer in this.flower) {
                    this.part_value.push(this.flower[index_outer].deep_name)
                }
            }

            // 第一次进页面
            if(Object.keys(this.part_list).length === 0) {
                for (let index_outer in this.part) {
                    let part_item = this.part[index_outer]
                    let first_option = part_item.option_list[0]
                    if(first_option) {
                        this.choose_part(part_item.category_key,part_item.category_name_cn,first_option.part_name_cn,first_option.part_key, first_option.model_path,part_item.no_cad)
                    }
                }
            }
            if(Object.keys(this.accessory_list).length === 0) {
                for (let index_outer in this.accessory) {
                    let deep_item = this.accessory[index_outer]
                    if(deep_item.option_list.length > 0) {
                        let first_option = deep_item.option_list[0]
                        this.choose_accessory(deep_item.deep_key,deep_item.deep_name,first_option.text, first_option.key)
                    }

                }
            }
            if(Object.keys(this.flower_list).length === 0) {
                for (let index_outer in this.flower) {
                    let deep_item = this.flower[index_outer]
                    if(deep_item.option_list.length > 0) {
                        let first_option = deep_item.option_list[0]
                        this.choose_flower(deep_item.deep_key, deep_item.deep_name, first_option.text, first_option.key)
                    }

                }
            }

            for(let j in this.accessory) {
                this.$set(this.filter_accessory, this.accessory[j].deep_key, 0)
                // console.log(this.accessory[j])
            }
        }
    }
</script>

<style lang="scss" scoped>
    .group-title {
        font-weight: bolder;
        font-size: 18px;
        margin: 0.5vw 0 -1vw;
        text-align: center;
    }
    .part-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 10px;
        .value {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 10px;
            color: #666666;
        }
    }
    .cate-box {
        margin: 30px 0;
        display: flex;
        flex-wrap: wrap;
        .cate {
            font-size: 15px;
            font-weight: 400;
            color: #666666;
            width: 180px;
            text-align: center;
            margin-bottom: 15px;
            margin-right: 8px;
            cursor: pointer;
            .img {
                position: relative;
                background: #ffffff;
                border: 1px solid #dddddd;
                opacity: 1;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 5px;
                .magnifier{
                    position: absolute;
                    bottom:5px;
                    right:5px;
                }
            }
        }
        .cate-active {
            font-weight: bold;
            color: #0f114a;
            .img {
                border: 1px solid #0f114a;
            }
        }
    }

    .no3d {
        .cate-box {
            .cate {
                width: 130px;
                .img {

                }
            }
        }
    }
    .select-active {
        position: relative;
    }
    .select-active:after {
        background-image: url("~@/assets/images/design/select@2x.png");
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 5px;
        top: 5px;
        content: "";
    }
</style>
